<template>
	<div class="bg">
    <!-- 搜索栏 -->
    <div class="top_search_part main_top_search">
      <div class="search_box">
        <div class="add_btn" @click="addNewOrder"><img class="add_icon" src="@/assets/addIcon.svg" />{{$t('message.AddTitle')}}</div>
      </div>
    </div>
    <!-- 搜索栏 -->		
		<!-- 订单管理列表 -->
		<div class="content">
		  <div class="tableBox">
		    <el-table id="orderList" :data="orderList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%" @sort-change="sortChange" @selection-change="selectionChange">
		      			  
			  <el-table-column type="selection" width="55"></el-table-column>
		      <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="65"></el-table-column>
		      <el-table-column :label="$t('message.BaoGuoName')" prop="NAME"></el-table-column>
		      <el-table-column :label="$t('message.BaoGuoQrcode')" prop="QRCODESTR"></el-table-column>
		      <el-table-column :label="$t('message.BaoGuoCode')" prop="CODE"></el-table-column>
		      <!-- <el-table-column :label="$t('message.CityName')" prop="CITY"></el-table-column> -->
		      <el-table-column :label="$t('message.AreaSuoShuName')" prop="JIEDAO"></el-table-column>
			  
		      <el-table-column :label="$t('message.customTableTitle5')" width="100" fixed="right" >
		        <template slot-scope="scope">
		          <div class="operate_btn_box">
                <el-button class="operation_btn updateBtn" type="text" size="small" @click.native.prevent="updateOrder(scope.row)"></el-button>
		            <el-button class="operation_btn delBtn" type="text" size="small" @click.native.prevent="delOrder(scope.row)"></el-button>
		          </div>
		        </template>
		      </el-table-column>
		    </el-table>
		  </div>
		  <el-pagination
		    @size-change="sizeChange"
		    @current-change="currentChange"
		    :current-page="page_no"
		    :page-sizes="pageSizes"
		    :page-size="page_size"
		    layout="total, sizes, prev, pager, next"
		    :total="totalSize"
		    class="tablePage">
		  </el-pagination>
		</div>
	<el-dialog :visible.sync="newOrder" :title="addOrderTitle" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false" width="60%" top="5vh">
	  <div class="dialog_box">
	    <div class="dialog_row">
	      <div class="dialog_item">
	        <span class="dialog_item_title">{{$t('message.BaoGuoName')}}</span>
	        <el-input v-model="BaoGUOName" :placeholder="$t('message.placeholder')"></el-input>
	      </div>
	      <div class="dialog_item">
	        <span class="dialog_item_title">{{$t('message.AreaSuoShuName')}}</span>
	        <!-- <el-input v-model="BaoGuoJieDao" :placeholder="$t('message.placeholder')"></el-input> -->			
			<el-select v-model="BaoGuoJieDao"  @change="BaoGuoJieDaoChange">
			  <el-option v-for="(item, index) in JieDaoList" :key="index" :label="item.CITY" :value="index"></el-option>
			</el-select>
	      </div>
	    </div>
	    <div class="dialog_row">
	      <div class="dialog_item">
	        <span class="dialog_item_title">{{$t('message.SortidTitle')}}</span>
	        <el-input v-model="BaoGUoQrcodestr" :placeholder="$t('message.placeholder')"></el-input>
	      </div>
	    </div>
	    
		<span slot="footer" class="dialog-footer">
	      <el-button @click="newOrder = false">{{$t('message.cancleText')}}</el-button>
	      <el-button type="primary" @click="addNewConfirm">{{$t('message.confirmText')}}</el-button>
	    </span>
	  </div>
	</el-dialog>
		
	</div>
</template>

<script>
  import { getKdBaoGuoList, setKdBaoGuo, delKdBaoGuo, KdBaoGuoAreaGetAll, HTTPS } from '@/api/getData.js'
  export default {
    name: 'ordersList',
    data () {
      return {
        page_no: 1,
        page_size: 10,
        pageSizes: [10, 20, 30, 50, 100],
        totalSize: 0,
        orderList: [],
        orderNum: '',
        orderSenderName: '',
        orderStatus:[],// [0, 1, 2],
		searchAcount:[this.$store.state.JHSS.personalUserid],
        orderAcountList:[],// 
        orderTime: null,
        orderProvince: [], // 收件省份
        orderSelProvince: '', // 收件省份选择
        remark: '',
        prop: null, // 排序字段
        order: '', // 排序方式，desc
        newOrder: false,
        newId: 0,
        // showOrderNumInput: false,
        newOrderNum: '',
        cityOptions: ['東京', '大阪'],
        addOrderTitle: '',
        isAdmin: false,
		
        JieDaoList: [],
		BaoGUoQrcodestr:'',
		BaoGuoJieDao:'',
		BaoGuoJieDaoCode:'',
		BaoGUOName:'',
      }
    },
    created () {
      this.isAdmin = this.$store.state.JHSS.personalUserid.includes('admin')
      let param = this.$store.state.JHSS_xiaobaolist_param
      if (param.PAGE) this.page_no = param.PAGE
      if (param.TYPE) this.page_size = param.TYPE
      //if (param.UADDTIME && param.DADDTIME) this.orderTime = [param.UADDTIME, param.DADDTIME]
      //if (param.STATE) this.orderStatus = param.STATE.split(',').map(item => { return parseInt(item) })
	  this.KdBaoGuoAreaGetAll()
      // 查询订单列表
      this.getOrderList(param)
    },
    methods: {
		//获取区域列表
		async KdBaoGuoAreaGetAll(){
			let res = await KdBaoGuoAreaGetAll()
			if (res.status !== 200) {
			  this.$message.error('network error：' + res.status)
			  return
			}
			this.JieDaoList = res.data.dt.map(item => {
			  // console.log(item.CITY)
			  return item
			})
		},
      // 查询订单列表
      async getOrderList (param) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        param = param || {}
		if(this.searchAcount=="")
		{
			param.ADDUSERID = this.$store.state.JHSS.personalUserid
		}else{
			param.ADDUSERID = this.searchAcount.join(',')
		}
		if(param.ADDUSERID == null || param.ADDUSERID=="")
		{
			param.ADDUSERID = this.$store.state.JHSS.personalUserid
		}
		
        param.STATE = this.orderStatus.join(',')
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        let res = await getKdBaoGuoList(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        this.exportJson = param
        // console.log(res.data.ds)
        this.totalSize = res.data.num
        let index = (this.page_no - 1) * this.page_size
        this.orderList = res.data.dt.map(item => {
          item.index = ++index
          item.addTime = item.ADDTIME.replace(/T/g, ' ')
          return item
        })
        this.$store.commit('setOrderManageParam', param)
      },
      sizeChange (val) {
        // console.log(val)
        this.page_size = val
        this.page_no = 1
        this.searchFun()
      },
      currentChange (val) {
        // console.log(val)
        this.page_no = val
        this.searchFun()
      },
      // 删除订单
      delOrders () {
        // console.log(this.selOrders)
        let list = this.selOrders.map(item => {
          return item.ID
        })
        this.delOrder({ ID: list.join(',') })
      },
      delOrder (obj) {
        // console.log(obj)
        this.$confirm(this.$t('message.orderPrompt'), this.$t('message.promptTitle'), {
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText')
        }).then(() => {
          this.del(obj.ID)
        }).catch(() => {
          this.$message(this.$t('message.canclePrompt'));
        });
      },
      async del (id) {
        let param = { ID: id }
        let res = await delKdBaoGuo(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          // this.page_no = 1
          this.searchFun()
        }
      },
      // 时间排序
      sortChange (obj) {
        // console.log(obj)
        // 根据时间排序（prop: addTime ，order: 'ascending', 'descending', null）
        this.prop = null
        if (obj.prop === 'addTime') {
          this.prop = 'ADDTIME'
          // param.ORDERNAME = 'ADDTIME'
        }
        this.order = ''
        if (obj.order === 'descending') {
          this.order = 'DESC'
          // param.DOA = 'DESC'
        }
        // this.page_no = 1
        this.searchFun()
      },	  
      imgSrc (name) {
        return imgSrc(name)
      },
      // 选择订单
      selectionChange (val) {
        this.selOrders = val
      },
      BaoGuoJieDaoChange (val) {
        console.log(val)
		console.log(this.JieDaoList[val])
        this.BaoGuoJieDao = this.JieDaoList[val].CITY
        this.BaoGuoJieDaoCode = this.JieDaoList[val].CODE
      },
      // 添加订单
      async addNewOrder () {    
        this.newOrder = true    
        let param = { USERID: this.$store.state.JHSS.personalUserid }        
        this.newId = 0
        // this.showOrderNumInput = false
        this.BaoGUoQrcodestr = ''
        this.BaoGuoJieDao = ''
        this.BaoGUOName = ''
        this.addOrderTitle = this.$t('message.AddTitle')
      },
	  // 确定添加订单
	  async addNewConfirm () {
	    if (!this.BaoGUOName) {
	      this.$message.error(this.$t('message.BaoGuoAddTitle1'))
	    } else if (!this.BaoGUoQrcodestr) {
	      this.$message.error(this.$t('message.BaoGuoAddTitle2'))
	    }  else if (!this.BaoGuoJieDao) {
	      this.$message.error(this.$t('message.BaoGuoAddTitle3'))
	    } else {
	      const loading = this.$loading({
	        lock: true,
	        text: 'Loading',
	        spinner: 'el-icon-loading',
	        background: 'rgba(0, 0, 0, 0.7)'
	      })
	      
	      let param = {
	        ID: this.newId,
	        GUDING2: this.$store.state.JHSS.personalUserid,
	        NAME:this.BaoGUOName,
			QRCODESTR:this.BaoGuoJieDaoCode+'-'+this.BaoGUoQrcodestr,
			CODE:this.BaoGuoJieDaoCode,
			JIEDAO:this.BaoGuoJieDao,
			GUDING1:this.BaoGUoQrcodestr			
	      }
		  let paramList=[param]
	      // console.log(param)
	      let res = await setKdBaoGuo(paramList)
	      loading.close()
	      if (res.status !== 200) {
	        this.$message.error('network error：' + res.status)
	        return
	      }
	      // console.log(res.data)
	      if (res.data.result !== '1') {
	        this.$message.error(res.data.message)
	      } else {
	        this.newOrder = false
	        this.page_no = 1
	        this.getOrderList()
	      }
	    }
	  },
	  // 修改订单
	  updateOrder (obj) {
	    // console.log(obj)
        this.addOrderTitle = this.$t('message.EditTitle')
	    this.newOrder = true
	    this.newId = obj.ID
	    // this.showOrderNumInput = true
	    this.BaoGUOName = obj.NAME
	    this.BaoGUoQrcodestr = obj.GUDING1
	    this.BaoGuoJieDao = obj.JIEDAO
	  }
    },
    computed: {
      uploadUrl () {
        return uploadImg()
      },
      url () {
        return HTTPS
      }
    }
  }
</script>

<style scoped>
.main_top_search {
  /* height: 180px; */
  height: 126px;
  flex-wrap: wrap;
}
.main_top_search :first-child {
  flex-wrap: wrap;
  flex-shrink: 1;
}
.main_top_search :first-child .search_item, .main_top_search :first-child .search_btn, .main_top_search :first-child .add_btn {
  /* margin-bottom: 10px; */
  margin-top: 10px;
}
.importBtnBox {
  flex-shrink: 0;
  height: 44px;
  border-radius: 4px;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 44px;
  margin-left: 28px;
  cursor: pointer;
  padding: 0 20px;
  display: flex;
  align-items: center;
}
.importBtn {
  flex-shrink: 0;
  display: inline-block;
  height: 44px;
  background: #0066FF;
  border-radius: 4px;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 44px;
  margin: 0 28px;
  cursor: pointer;
  padding: 0 20px;
}
.barCodeImg {
  width: 52px;
  height: 41px;
}
.addItemInput, .addresseeInput {
  min-height: 46px;
  border: 1px solid #979797;
  border-radius: 4px;
  padding: 0 11px;
  font-size: 18px;
  color: #666666;
  text-align: left;
}
.addItemInput {
  width: 197px;
}
.addItemSelect {
  width: 197px;
  min-height: 46px;
}
.addresseeInput {
  width: 525px;
}
.remarkInput {
  width: 650px;
  min-height: 46px;
  font-size: 18px;
  color: #666666;
  text-align: left !important;
}
/deep/ .remarkInput .el-textarea__inner {
  text-align: left;
}
.checkBtn {
  border: 0;
  font-size: 18px;
  color: #0066FF;
}


/* 导入文件 */
.importLine {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>

